'use client'

import React, { FC, ReactElement } from 'react'
import CollectionsFeed from '@/components/collections-feed'
import classNames from 'classnames'

const _TABS = ['nft', 'brc20', 'names']

const CollectFeed: FC<{
	title?: string
	className?: string
	isMobile: boolean
	collections: any[]
	infinite?: boolean
	category?: string
}> = (props): ReactElement => {
	const { isMobile, collections } = props

	return (
		<div className={classNames(props?.className, 'w-full')}>
			<CollectionsFeed
				category={props.category}
				title={props.title || 'Collect'}
				isMobile={isMobile}
				items={collections}
				infinite={props?.infinite}
			/>
		</div>
	)
}

export default CollectFeed
